module.exports = __webpack_public_path__ + "img/sting_rtl2_juin2021.69461604.jpg";